import React from 'react';
import cn from 'classnames';

import LogoIcon from 'assets/svg/icon.svg';

import classes from './Logo.module.scss';

const LogoS = () => {
  return (
    <div className={cn(classes.logo, classes.logo_s)}>
      <img src={LogoIcon} width="24" height="32" alt="" />
    </div>
  );
};

export default LogoS;
